import { get, post, destroy } from './base';
import axios from 'axios';

const token = () => localStorage.getItem('token');
const apiBase = process.env.REACT_APP_API_ENDPOINT;

export const SftpServ = {

    list: (remotePath) =>
        get(`/sftp/list`, { params: { path: remotePath } }),
upload: (remotePath, files, relativePaths = [], onProgress, pocId) => {
    const form = new FormData();

    form.append('path', remotePath);
    form.append('pocId', pocId);
    form.append('relativePaths', JSON.stringify(relativePaths));

    files.forEach(f => form.append('files', f));

    return axios.post(`${apiBase}/sftp/upload`, form, {
        headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': 'Bearer ' + token(),
            'Origin': window.location.origin,
        },
        onUploadProgress: onProgress
            ? (e) => onProgress(
                Math.round((e.loaded * 100) / (e.total || 1))
            )
            : undefined,
    }).then(r => r.data);
},

    download: (remotePath) =>
        axios.get(`${apiBase}/sftp/download`, {
            params: { path: remotePath },
            responseType: 'blob',
            headers: {
                'Authorization': 'Bearer ' + token(),
                'Origin': window.location.origin,
            }
        }).then(r => r.data),

    delete: (remotePath, isDirectory) =>
        destroy(`/sftp/delete`, { data: { path: remotePath, isDirectory } }),

    rename: (oldPath, newPath) =>
        post(`/sftp/rename`, { oldPath, newPath }),

    mkdir: (remotePath) =>
        post(`/sftp/mkdir`, { path: remotePath }),

    readFile: (remotePath) =>
        get(`/sftp/read`, { params: { path: remotePath } }),

    writeFile: (remotePath, content) =>
        post(`/sftp/write`, { path: remotePath, content }),
};
